// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5db14889","455":"007c4225","977":"d4384893"}[chunkId] + ".chunk.js";
};